<script setup lang="ts">
import { Icon } from "@/components/ui"
import { useTranslation } from "@/composables"

interface FreemiumUpgradeCardProps {
  upgradeUrl?: string
  variant?: "default" | "mini"
}

withDefaults(defineProps<FreemiumUpgradeCardProps>(), {
  variant: "default",
})

const { t } = useTranslation()
</script>

<template>
  <div>
    <a
      :href="upgradeUrl"
      target="_blank"
      rel="noopener noreferrer"
      data-test="upgrade-now-link"
      class="group bg-premium flex items-center active:scale-[0.98] transition-all duration-200 ease-out cursor-pointer"
      :class="[{
        'gap-2 justify-center w-full max-w-full py-2 px-4 text-[#072a47] ring-1 ring-black/5 hover:ring-black/10 rounded-lg': variant === 'mini',
        'gap-3 w-full py-3 px-4 rounded-2xl': variant !== 'mini',
      }]"
    >
      <template v-if="variant === 'mini'">
        <div class="shrink-0 bg-white rounded-full p-1.5 ring-2 ring-white/30 group-hover:ring-white/60 transition-shadow duration-200">
          <Icon icon="Crown" size="xs" />
        </div>
        <span class="font-heading font-bold text-sm leading-tight truncate min-w-0 group-hover:font-black">
          {{ t("freemium_upgrade_card.title") }}
        </span>
      </template>
      <template v-else>
        <div class="shrink-0 bg-white rounded-full p-2.5 ring-2 ring-white/30 group-hover:ring-white/60 transition-shadow duration-200">
          <Icon icon="Crown" size="sm" />
        </div>
        <div class="min-w-0 flex-1 text-left text-sm text-[#072a47]">
          <h5 class="font-heading font-bold text-lg flex items-center gap-1">
            {{ t("freemium_upgrade_card.title") }}
            <Icon icon="MoveUpRight" size="xs" class="group-hover:translate-x-0.5 transition-transform duration-200 shrink-0" />
          </h5>
          <p class="font-body mt-0.5 leading-tight">
            {{ t("freemium_upgrade_card.description") }}
          </p>
        </div>
      </template>
    </a>
  </div>
</template>
